import { isDev } from './isDev'

export const clientId = extractClientId()

function extractClientId() {
  if (isDev) return 'sandbox'
  const parts = window.location.hostname.split('.')
  return parts[0]
}
